const changeAmountFirstStep = (state, action) => {
  if (state === undefined) {
    return 1;
  }

  switch (action.type) {
    case 'RESET_TAB_STATE':
      return 1;
    case 'CHANGE_AMOUNT_FIRST_STEP':
      return action.payload;
    default:
      return state.amountFirstStep;
  }
};

export { changeAmountFirstStep };
